<template>
  <section class="h-400 mb-12">
    <v-container fluid class="pa-0">
      <v-row>
        <v-col class="pa-0" cols="12" md="6">
          <div
            :class="$vuetify.theme.dark ? 'grey darken-4' : 'bg-light-blue'"
            class="h-400 px-12"
          >
            <v-container class="px-12 fill-height">
              <v-row>
                <v-col cols="12">
                  <h3 class="text-h3 font-weight-bold mb-3">
                    Your Print, Your Art
                  </h3>
                  <h2 class="text-subtitle-1 font-weight-thin">
                    Buy prints with a certificate of authenticity, brought to
                    you by who understand and appreciate artwork
                  </h2>
                  <v-btn
                    nuxt
                    to="/shop/prints"
                    depressed
                    x-large
                    dark
                    class="h-60 ma-0 mt-6"
                  >
                    Shop now
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="hidden-sm-and-down pa-0">
          <nuxt-link class="hero-image" to="/shop/prints">
            <div class="home-photo-caption">
              <p class="text-body-2">
                Photo by Dermot O'Mahony
              </p>
            </div>
          </nuxt-link>
        </v-col>
      </v-row>
    </v-container>
  </section>
  <!-- <section class="py-12 bg-hero mb-6">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="text-center">
            <h3 class="display-1 font-weight-bold mb-2">
              Astonishing Artwork
            </h3>
            <p class="title font-weight-bold">
              Your artwork will be printed on premium paper using the latest
              technology. Our team manually handcrafts each print to perfection.
            </p>
            <v-btn
              nuxt
              to="/shop/prints"
              depressed
              x-large
              color="primary"
              class="h-60 ma-0 mt-4"
            >
              Shop now
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section> -->
</template>

<script>
export default {
  name: 'ShopHero'
}
</script>

<style scoped>
.h-400 {
  height: 400px;
}
.bg-light-blue {
  background-color: #e1f5fe;
}
.hero-image {
  background-image: url('https://storage.100asa.com/staging/3948/tr:n-full_s_v5/d7d89314-59a3-4366-870a-3bc712b21e1e_Fbg-_bKgw');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  position: relative;
  text-decoration: none;
  width: 100%;
  height: 400px;
}
.home-photo-caption {
  color: white;
  position: absolute;
  bottom: 0;
  right: 25px;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.7);
}
.bg-hero {
  background: url('/images/shop/shop-hero.jpeg') 50% 50% no-repeat transparent;
  background-size: cover;
}
</style>
